// Generated by scripts/gen-standard-page-translations.mjs. Do not edit.
import type { CoreLanguageType } from 'shared/src/types/languages.type';
import type { ReportButtonLabels } from '../report-button-content';
import { reportButton as lang_bn } from './bn/report-button';
import { reportButton as lang_ca } from './ca/report-button';
import { reportButton as lang_cy } from './cy/report-button';
import { reportButton as lang_eu } from './eu/report-button';
import { reportButton as lang_ga } from './ga/report-button';
import { reportButton as lang_gd } from './gd/report-button';
import { reportButton as lang_gl } from './gl/report-button';
import { reportButton as lang_hi } from './hi/report-button';
import { reportButton as lang_it } from './it/report-button';
import { reportButton as lang_ja } from './ja/report-button';
import { reportButton as lang_mi } from './mi/report-button';
import { reportButton as lang_mr } from './mr/report-button';
import { reportButton as lang_nl } from './nl/report-button';
import { reportButton as lang_pl } from './pl/report-button';
import { reportButton as lang_pt_BR } from './pt-BR/report-button';
import { reportButton as lang_pt_PT } from './pt-PT/report-button';
import { reportButton as lang_rm } from './rm/report-button';
import { reportButton as lang_sv } from './sv/report-button';
import { reportButton as lang_ta } from './ta/report-button';
import { reportButton as lang_te } from './te/report-button';

export const reportButtonTranslations: Partial<Record<CoreLanguageType, ReportButtonLabels>> = {
  'bn': lang_bn,
  'ca': lang_ca,
  'cy': lang_cy,
  'eu': lang_eu,
  'ga': lang_ga,
  'gd': lang_gd,
  'gl': lang_gl,
  'hi': lang_hi,
  'it': lang_it,
  'ja': lang_ja,
  'mi': lang_mi,
  'mr': lang_mr,
  'nl': lang_nl,
  'pl': lang_pl,
  'pt-BR': lang_pt_BR,
  'pt-PT': lang_pt_PT,
  'rm': lang_rm,
  'sv': lang_sv,
  'ta': lang_ta,
  'te': lang_te,
};
